// @ts-nocheck
import React, { FunctionComponent } from 'react';
import { FieldProps, getIn } from 'formik';
import { useFormikContext } from 'formik';

// MUI
import TextField, { TextFieldProps } from '@mui/material/TextField';

// Properties
import * as styles from './FormInputMask.styles';
import InputMask from 'react-input-mask';

// Common
import { GENERAL } from '../../../../../constants';

const FormInputMask: FunctionComponent<FieldProps & TextFieldProps> = props => {
    const { disabled, error, helperText, field, form, ...rest } = props;

    const { setFieldValue } = useFormikContext();

    const isTouched = getIn(form.touched, field.name);
    const errorMessage = getIn(form.errors, field.name);

    return (
        <InputMask
            mask={'+48 999 999 999'}
            maskChar='_'
            alwaysShowMask
            disabled={disabled ?? form.isSubmitting}
            error={error ?? Boolean(isTouched && errorMessage)}
            helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
            {...rest}
            onChange={(e: any) => {
                const value = e && e.target && e.target.value || field.value;
                const val = value.replace('+48', '').replaceAll(' ', '').replaceAll('_', '');
                setFieldValue('phoneNumber', val);
            }}
        >
            {(field) => <TextField
                {...field}
                sx={styles.textField}
                variant="outlined"
                size="small"
                margin="normal"
                InputLabelProps={{
                    shrink: true,
                }}
                label={GENERAL.PERSONAL_PHONE}
            />}
        </InputMask>
    );
};


export default FormInputMask;
